import { render, staticRenderFns } from "./addorg-modal.vue?vue&type=template&id=b6bb6fae&scoped=true&"
import script from "./addorg-modal.vue?vue&type=script&lang=js&"
export * from "./addorg-modal.vue?vue&type=script&lang=js&"
import style0 from "./addorg-modal.vue?vue&type=style&index=0&id=b6bb6fae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bb6fae",
  null
  
)

export default component.exports